<template>
  <div>
    <header></header>
    <!-- 内容 -->
    <div class="content">
      <!-- 左侧用户 -->
      <div class="users">
        <div class="block">
          <el-upload
            class="avatar-uploader"
            action="#"
            :http-request="upLoad"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-avatar
              class="h-img"
              :size="80"
              :src="userdata.avatar==null?'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png':userdata.avatar"
            ></el-avatar>

            <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
          </el-upload>
        </div>
        <div class="u-name">
          <div class="u-msg">
            <h3>{{userdata.username}}</h3>
          </div>

          <div class="u-msg">
            <h3>{{userdata.phone}}</h3>
          </div>
        </div>
        <!-- 分割线 -->
        <div class="line"></div>
        <!-- 账号管理 -->
        <div class="userinfo">
          <h3 style="margin-left:0px">账号管理</h3>
          <div :class="msg?'u-personal public':'u-personal' " @click="mymsg()">
            <div class="shape"></div>
            <div class="u-text">个人信息</div>
          </div>
          <!-- @click="mybook()" -->
          <div :class="book?'u-personal public':'u-personal' " @click="mybook()">
            <div class="shape"></div>
            <div class="u-text">我的证书</div>
          </div>
          <div :class="changepass?'u-personal public':'u-personal' " @click="mychange()">
            <div class="shape"></div>
            <div class="u-text">修改密码</div>
          </div>
        </div>
      </div>
      <!-- 右侧内容 -->
      <!-- <div class="r_content"></div> -->
      <!-- 个人信息 -->
      <el-card class="r_content" v-show="msg">
        <div slot="header" class="clearfix">
          <div class="shape1"></div>
          <div style="font-size:16px;color:#409eff">个人信息</div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          hide-required-asterisk
          label-position="left"
        >
          <!-- <el-form-item prop="uname" label="昵称">
            <el-input placeholder="昵称" v-model="ruleForm.uname" clearable></el-input>
          </el-form-item>-->
          <el-form-item prop="phone" label="手机号">
            <el-input placeholder="手机号" maxlength="11" v-model="ruleForm.phone" clearable></el-input>
          </el-form-item>
          <el-form-item prop="company" label="公司名称">
            <el-input placeholder="公司名称" v-model="ruleForm.company" clearable></el-input>
          </el-form-item>
          <el-form-item prop="username" label="真实姓名">
            <el-input placeholder="真实姓名" v-model="ruleForm.username" clearable></el-input>
          </el-form-item>
        </el-form>
        <el-button class="form_btn" type="primary" @click="changeMsg()">保存</el-button>
      </el-card>
      <!-- 我的证书 -->
      <el-card class="r_content" v-show="book">
        <div slot="header" class="clearfix">
          <div class="shape1"></div>
          <div style="font-size:16px;color:#409eff">我的证书</div>
        </div>
        <!-- 证书查看  -->
        <div class="b-content">
          <div class="style-book" v-for="(item,i) in bookdata" :key="i">
            <div class="b-pic">
              <img :src="'https://help.tizdata.com/'+item.course.thumb" alt />
            </div>
            <div class="b-msg">
              <h3>{{item.course.name}}</h3>
              <div class="b-date">
                <span>证书获得日期：</span>
                <span>{{item.achieve_time}}</span>
              </div>
              <div class="b-line"></div>
              <el-button type="primary" @click="create(item.course.id)">查看证书</el-button>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 生成证书，弹窗 -->
      <el-dialog title="课程证书" :visible.sync="dialogVisible" width="28%" top="1%">
        <img class="mybook" :src="imgbook" alt />
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改密码 -->
      <el-card class="r_content" v-show="changepass">
        <div slot="header" class="clearfix">
          <div class="shape1"></div>
          <div style="font-size:16px;color:#409eff">修改密码</div>
        </div>
        <el-form
          :model="reset"
          :rules="rules"
          ref="reset"
          label-width="80px"
          hide-required-asterisk
          label-position="left"
        >
          <el-form-item prop="o_password" label="旧密码">
            <el-input
              type="password"
              placeholder="旧密码"
              v-model="reset.o_password"
              clearable
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="n_password" label="新密码">
            <el-input
              type="password"
              placeholder="新密码"
              v-model="reset.n_password"
              clearable
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <!-- 确定密码 -->
          <el-form-item prop="checkPass" label="确定密码">
            <el-input
              type="password"
              placeholder="确定密码"
              v-model="reset.checkPass"
              clearable
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button class="form_btn" type="primary" @click="changPswd()">保存</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Utils } from '../../api/utilPort.js'
let utils = new Utils()
export default {
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.reset.n_password !== '') {
          this.$refs.ruleForm.validateField('n_password')
        }
        callback()
      }
    }
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      }
      callback()
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.reset.n_password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      imageUrl: '',
      select: true,
      msg: true,
      book: false,
      changepass: false,
      dialogVisible: false,
      imgbook: '',
      userdata: [],
      // 证书查看
      bookdata: [],
      ruleForm: {
        phone: '',
        username: '',
        company: '',
        uname: '',
        checkPass: '',
      },
      reset: {
        o_password: '',
        n_password: '',
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            min: 11,
            max: 11,
            message: '请输入正确手机号',
            trigger: 'blur',
            validator: validatePhone,
          },
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        username: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        uname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        o_password: [
          { validator: validatePass1, trigger: 'blur' },
          {
            min: 6,
            max: 18,
            message: '密码最小6位',
            trigger: 'blur',
          },
        ],
        n_password: [
          { validator: validatePass, trigger: 'blur' },
          {
            min: 6,
            max: 18,
            message: '密码最小6位',
            trigger: 'blur',
          },
        ],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
    me() {
      utils
        .get('/user/me/')
        .then((res) => {
          console.log(res)
          this.userdata = res.data
          this.ruleForm.username = res.data.username
          this.ruleForm.company = res.data.company
          this.ruleForm.phone = res.data.phone
        })
        .catch((err) => {
          console.log(err)
        })

      utils
        .get('/user/certificates/')
        .then((res) => {
          console.log(res)
          this.bookdata = res.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    mybook() {
      this.msg = false
      this.changepass = false
      this.book = true
    },
    mymsg() {
      this.changepass = false
      this.book = false
      this.msg = true
    },
    mychange() {
      this.msg = false
      this.book = false
      this.changepass = true
    },
    create(id) {
      this.dialogVisible = true
      utils
        .get('/course/' + id + '/certificate/')
        .then((res) => {
          console.log(res)
          this.imgbook = 'https://help.tizdata.com' + res.data.url
        })
        .catch((err) => {
          console.log(err)
        })
    },

    changeMsg() {
      utils
        .patch('/user/update_profile/', {
          username: this.ruleForm.username,
          company: this.ruleForm.company,
        })
        .then((res) => {
          console.log(res)
          if (res.status == 200) {
            // this.$message.success('修改成功')
            alert('修改成功')
            this.$router.go(0)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changPswd() {
      this.$refs.reset.validate((valid) => {
        //   console.log(valid)
        if (!valid) {
          this.$message.error('请输入正确密码')
        } else {
          utils
            .post('/user/change_password/', this.reset)
            .then((res) => {
              console.log(res)
              this.$message.success(res.data.message)
              localStorage.removeItem('token')
              this.$router.push('/login')
            })
            .catch((err) => {
              console.log(err)
              this.$message.error(err.data.message)
            })
        }
      })
    },
    upLoad(f) {
      const formData = new FormData()
      formData.append('image', f.file)
      console.log(f)
      console.log(formData)
      utils
        .post('/image/', formData)
        .then((res) => {
          console.log(res)
          console.log('上传成功')
          this.imageUrl = 'https://help.tizdata.com' + res.data.image
          utils
            .patch('/user/update_profile/', {
              avatar: this.imageUrl,
            })
            .then((res) => {
              console.log(res)
              if (res.status == 200) {
                // this.$message.success('修改成功')
                window.localStorage.setItem('avatar', res.data.avatar)
                alert('修改成功')
                this.$router.go(0)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleAvatarSuccess(res, file) {
      this.headUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt3M = file.size / 1024 / 1024 < 3
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt3M) {
        this.$message.error('上传头像图片大小不能超过 3MB!')
      }
      return isJPG && isLt3M
    },
  },
  created() {
    this.me()
  },
}
</script>

<style lang="less" scoped>
// 主内容
.content {
  width: 1400px;
  display: flex;
  margin: 30px auto;
}
// 左侧用户
.users {
  width: 350px;
  height: 500px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  margin-right: 50px;
  .block {
    width: 350px;
    height: 80px;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    position: relative;
  }
  .u-name {
    width: 350px;
    height: 60px;

    margin-top: 20px;
  }
  .u-msg {
    width: 350px;
    height: 30px;
    display: flex;
    justify-content: center;
  }
  .line {
    width: 280px;
    border-top: 1px solid #f0f2f9;
    margin: 0 auto;
  }
  .userinfo {
    width: 350px;
    height: 250px;
    padding: 30px;
  }
  .shape {
    width: 8px;
    height: 16px;
    background-color: #dadee9;
    border-radius: 3px;
    float: left;
    margin: 0 10px;
  }
  .u-text {
    float: left;
    font-size: 16px;
  }
  .u-personal {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    margin: 10px 0;
    border-radius: 10px;
    cursor: pointer;
  }
  .u-book {
    width: 100%;
    height: 30px;
  }
  .u-change {
    width: 100%;
    height: 30px;
  }
}
// .users .userinfo .u-personal:hover {
//   background-color: #409eff;
//   color: #eef3fb;
// }
// 右侧内容
.r_content {
  width: 1050px;
  height: 700px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  // padding-top: 0;
  position: relative;

  /deep/.el-card__body {
    padding: 20px 0;
  }
  .clearfix {
    display: flex;
    align-items: center;
  }
  .shape1 {
    width: 8px;
    height: 16px;
    background-color: #409eff;
    border-radius: 3px;
    float: left;
    margin: 0 15px;
  }
  .form_btn {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
  }
  .el-form-item {
    margin: 30px 0;
  }
  .el-form-item:nth-child(1) {
    margin-top: 10px;
  }
}
.public {
  background-color: #409eff;
  color: #eef3fb;
}
.h-upload {
  height: 40px;
  width: 80px;
  // background-color: rgba(164, 224, 164, 0.4);
  position: absolute;
  bottom: 0;
  left: 10%;
  // transform: translateX(-50%);
  font-size: 12px;
  // border-bottom-left-radius: 80px;
  // border-bottom-right-radius: 80px;
}
.h-img:hover + .h-upload {
  display: block !important;
}
/deep/ .el-avatar > img {
  width: inherit;
  height: inherit;
}
.style-book {
  width: 100%;
  min-height: 170px;
  display: flex;
  padding-bottom: 20px;
  .b-pic {
    width: 30%;
    height: 150px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }
  .b-msg {
    width: 70%;
    min-height: 150px;
    margin-left: 30px;
    position: relative;
    .b-date {
      position: absolute;
      bottom: 15px;
      span {
        color: rgba(172, 172, 169, 0.767);
      }
    }
    .b-line {
      width: 100%;
      height: 0px;
      border-bottom: 1px solid #ebeef5;
      position: absolute;
      bottom: 0;
    }
    .el-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
    }
  }
}
.b-content {
  height: 580px;
  overflow-y: auto;
}
.mybook {
  width: 100%;
  height: 100%;
  border: 1px solid #000;
}
</style>